package org.example.project.enginevertrieb

import androidx.compose.runtime.*
import org.example.project.settings.*
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

// Contact and qualification components cloned from the original Flow, scoped to LinkedIn.
@Composable internal fun LinkedInQualification(lead: All, definitionen: List<All>, enabled: Boolean, update: ((All) -> All) -> Unit, showEmptyState: Boolean = true, save: () -> Unit) {
    val checkboxes = definitionen.sortedWith(compareBy<All> {
        it.linkedinDmCheckboxPrio.takeIf { prio -> prio > 0 } ?: Int.MAX_VALUE
    }.thenBy { it.linkedinDmCheckboxId })
    if (checkboxes.isEmpty() && showEmptyState) {
        Div({ style { color(UISettings.STATE_BUTTON_TEXT); lineHeight("1.5") } }) {
            Text("In Akquise Einstellungen sind noch keine aktiven Felder angelegt.")
        }
    }
    if (checkboxes.isNotEmpty()) {
        LinkedInQualSection("Checkboxen") {
            checkboxes.forEach { definition ->
                key(definition.linkedinDmCheckboxId) { Div({ style { minWidth(0.px) } }) {
                    LinkedInToggle(definition.linkedinDmCheckboxText, lead.linkedinDmCheckboxWerte[definition.linkedinDmCheckboxId] == true, enabled) { checked ->
                        update { current ->
                            current.copy(linkedinDmCheckboxWerte = current.linkedinDmCheckboxWerte + (definition.linkedinDmCheckboxId to checked))
                        }
                        save()
                    }
                } }
            }
        }
    }
}

@Composable private fun LinkedInQualSection(title: String, content: @Composable () -> Unit) = Div {
    Div({ style { property("text-transform", "uppercase"); fontWeight("700"); fontSize(12.px); letterSpacing(.7.px); textAlign("center"); marginBottom(10.px) } }) { Text(title) }
    Div({ style { display(DisplayStyle.Grid); gridTemplateColumns("repeat(2, minmax(0, 1fr))"); gap(4.px, 12.px) } }) { content() }
}

@Composable private fun LinkedInToggle(label: String, checked: Boolean, enabled: Boolean, onChange: (Boolean) -> Unit) = Label(attrs = { style { display(DisplayStyle.Flex); gap(8.px); alignItems(AlignItems.Center); margin(10.px, 0.px); fontSize(14.px) } }) {
    LumaticaCheckbox(checked = checked, enabled = enabled, onChange = onChange); Text(label)
}
